import { Block, Text } from '@williamhill/rosi-ui-shared/src/components/typography';
import React from 'react';
import styled from 'styled-components';
import { PriceOdds } from '../../model';

type PriceComponentProps = {
  price: PriceOdds | null;
  originalPrice?: PriceOdds | null;
  isVoided: boolean;
};

export const PriceComponent = ({ price, originalPrice, isVoided }: PriceComponentProps) => {
  return (
    <PriceComponentWrapper>
      {originalPrice && (
        <OriginalText weight="regular" size="sm">
          {originalPrice.a}
        </OriginalText>
      )}
      {price && (
        <OddsText weight="regular" size="sm" isVoided={isVoided && !originalPrice}>
          {price.a}
        </OddsText>
      )}
    </PriceComponentWrapper>
  );
};

const PriceComponentWrapper = styled(Block)`
  > * + * {
    margin-left: 0.5rem;
  }
`;

const OriginalText = styled(Text)`
  text-decoration: line-through ${({ theme }) => theme.colors.neutral};
  color: ${({ theme }) => theme.colors.neutral};
`;

const OddsText = styled(Text)<{ isVoided?: boolean }>`
  color: ${({ theme }) => theme.colors.price};

  ${({ theme, isVoided }) =>
    isVoided &&
    `
    text-decoration: line-through ${theme.colors.neutral};
    color: ${theme.colors.neutral};
  `}
`;
